import styled from '@emotion/styled';
import {
    NotificationStatusWrap,
    NotificationWrap,
} from '@shared/components/core/alertNotification/CommonAlertNotificationStyles';
import TextButton from '@shared/components/core/button/TextButton';
import Icons from '@shared/components/core/images/Icons';
import { BodyLarge, DisplaySmall, LabelMedium } from '@shared/components/core/text/Typography';
import NotificationContainer from '@shared/hooks/state/NotificationContainer';
import useRelativeTime from '@shared/hooks/useRelativeTime';
import INotificationModel from '@shared/models/users/NotificationModel';
import { useTranslation } from 'react-i18next';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { StyledMarkdownContainer } from '../core/text/MarkdownTypography';

const MarkdownLinkRenderer = (props: any) => {
    if (props.href.startsWith('http')) {
        return (
            <a href={props.href} target="_blank" rel="noopener noreferrer">
                {props.children}
            </a>
        );
    }
    return <a href={props.href}>{props.children}</a>;
};

const NotificationCard: React.FC<INotificationModel> = (props) => {
    const { t } = useTranslation();
    const getRelativeTime = useRelativeTime();
    let { isRead, id, title, subtitle, markdown, notificationType, isDisabled, startDate } = props;
    const notificationContainer = NotificationContainer.useContainer();
    const handleMarkAsRead = () => {
        isRead = true;
        notificationContainer.markNotificationRead(id);
    };

    return (
        <NotificationWrap data-isread={isRead}>
            <ContentWrap>
                <DisplaySmall as="h2">{title}</DisplaySmall>
                <BodyLarge>{subtitle}</BodyLarge>
                <StyledMarkdownContainer>
                    <Markdown remarkPlugins={[remarkGfm]} components={{ a: MarkdownLinkRenderer }}>
                        {markdown}
                    </Markdown>
                </StyledMarkdownContainer>
                <NotificationStatusWrap>
                    <LabelMedium>Posted: {getRelativeTime(new Date(startDate))}</LabelMedium>
                    {isRead ? (
                        <LabelMedium>
                            <Icons name="read" size={16} ariaLabel={t('common:notifications.seen')} />
                        </LabelMedium>
                    ) : (
                        <TextButton variant="control" disabled={isRead} onClick={handleMarkAsRead}>
                            {isRead ? t('common:notifications.seen') : t('common:notifications.markAsRead')}
                        </TextButton>
                    )}
                </NotificationStatusWrap>
            </ContentWrap>
        </NotificationWrap>
    );
};
const ContentWrap = styled.div``;

export default NotificationCard;
